import React, { useEffect, useState } from "react";
import { faEdit, faEye, faRobot, faSave, faUser, faUserTie } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem, TextField, Tooltip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  callCommentHandler,
  callStatusReasonHandler,
  callDetailModal,
  getCallDetailsByIdHandler,
  getConversationDetailsByIdHandler,
  updateComment,
  updateReason,
} from "src/store/slices/callSlice";
import { ThunkDispatch } from "@reduxjs/toolkit";
import ConversationDetailModal from "./ConversationModal";
import { useTranslation } from "react-i18next";
import AudioPlayer from "../AudioPlayer";
import { convertUTCToLocalTime } from "src/common/utils";
import { getStatusClass } from "src/common/utils";
import { AudioProvider } from '../AudioContext';
import { RootState } from "src/store/store";
import { CALL, COMMENT, FULFILLED, UPDATEREASONSTATUS } from "src/common/constants";
import { toast } from "react-toastify";
import { clearAllAudioPlayers, getAllAudioPlayers } from "../UI/AudioManager";

const CallDetailModal = ({ selectedCall }: any) => {
  const dispatch: ThunkDispatch<object, object, any> = useDispatch();

  const [conversations, setConversation] = useState<any>([]);
  const [showConversationModal, setShowConversationModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const showCallDetailModal = useSelector(
    (state: RootState) => state.calls.showCallDetailsModal
  );

  const { commentValue } = useSelector((state: RootState) => state.calls)
  const { t } = useTranslation("common");
  useEffect(() => {
    if (selectedCall?.data?.comment) {
      dispatch(callCommentHandler(selectedCall.data.comment))
    }
  }, [selectedCall])
  if (!selectedCall || !selectedCall.data) {
    return <div>No Record Found</div>;
  }
  const { vonageCallId, bookings, callAttachment, from, to, status, createdAt, statusReason, channel, disconnectedBy } = selectedCall.data;
  const handleConversation = async (id: any) => {
    const data = {
      id: id,
    };
    await dispatch(getConversationDetailsByIdHandler(data))
      .then((res: any) => {
        setConversation(res.payload);
      })
      .catch((err: any) => {
        throw err;
      });
    setShowConversationModal(true);
  };
  const reasonArray = [
    { "value": "", "label": "Select Reason" },
    { "value": "Early Transfers", "label": "Early Transfers" },
    { "value": "Slot-based Transfers", "label": "Slot-based Transfers" },
    { "value": "Other Transfers", "label": "Other Transfers" },
    { "value": "Vehicle-specific Transfers", "label": "Vehicle-specific Transfers" },
    { "value": "On-hold Transfers", "label": "On-hold Transfers" },
    { "value": "Finalized Transfers", "label": "Finalized Transfers" },
    { "value": "Early Call Drop", "label": "Early Call Drop" },
    { "value": "Slot-Based Hang-Up", "label": "Slot-Based Hang-Up" },
    { "value": "Other Hang-Ups", "label": "Other Hang-Ups" },
    { "value": "Transport-Specific Hang-Up", "label": "Transport-Specific Hang-Up" },
    { "value": "On-Hold Disconnection", "label": "On-Hold Disconnection" }
  ];

  const handleChangeStatusReason = (event: any, vonageCallID: any) => {
    if (event.target.value) {
      const data = {
        statusReason: event.target.value,
        callId: vonageCallID
      }
      dispatch(updateReason(data)).then(async (res: any) => {
        if (res?.type === `${(CALL)}/${UPDATEREASONSTATUS}/${FULFILLED}`) {
          toast.success("Status Reason Updated Succesfully!", {
            position: "top-right",
            autoClose: 3000,
          });
          const data = { id: vonageCallID };
          const callDetails: any = await dispatch(getCallDetailsByIdHandler(data))
          dispatch(callStatusReasonHandler(true))
          handleCloseCallDetailModal()
        } else {
          toast.error('Status Reason Updated Failed!', {
            position: "top-right",
            autoClose: 2500,
          });
        }
      })
    }
  }

  const handleCloseCallDetailModal = () => {
    dispatch(callDetailModal(false));
    const players = getAllAudioPlayers();
    Object.values(players).forEach(player => {
      selectedCall?.data?.channel === 'CALL' && player?.pause?.();
    });
    clearAllAudioPlayers();
  }

  const handleCommentChange = (e: any) => {
    dispatch(callCommentHandler(e.target.value));
  }

  const submitComment = (comment: any, vonageCallID: any) => {
    const data = {
      comment: commentValue,
      callId: vonageCallID
    }
    dispatch(updateComment(data)).then(async (res: any) => {
      if (res?.type === `${(CALL)}/${COMMENT}/${FULFILLED}`) {
        toast.success("Comment Updated Succesfully!", {
          position: "top-right",
          autoClose: 3000,
        });
        setIsEdit(false);
      } else {
        toast.error('Status Reason Updated Failed!', {
          position: "top-right",
          autoClose: 2500,
        });
      }
    })
  }

  return (
    <>
      <AudioProvider>
        <div>
          <div className="table-responsive">
            <table className="video-details-table">
              <tbody>
                <tr className="table-row">
                  <td className="table-cell-header">{t("common.callId")}</td>
                  <td className="table-cell">{vonageCallId}</td>
                </tr>
                <tr className="table-row">
                  <td className="table-cell-header">{t("common.bookingId")}</td>
                  <td className="table-cell">
                    {bookings && bookings.length > 0 && bookings[0].bookingId
                      ? bookings[0].bookingId
                      : "N/A"}
                  </td>
                </tr>
                <tr className="table-row">
                  <td className="table-cell-header">{t("common.from")}</td>
                  <td className="table-cell">{from}</td>
                </tr>
                <tr className="table-row">
                  <td className="table-cell-header">{t("common.to")}</td>
                  <td className="table-cell">{to}</td>
                </tr>
                <tr className="table-row">
                  <td className="table-cell-header">
                    {t("common.vendorBookingId")}
                  </td>
                  <td className="table-cell">
                    {bookings &&
                      bookings.length > 0 &&
                      bookings[0].vendorBookingId
                      ? bookings[0].vendorBookingId
                      : "N/A"}
                  </td>
                </tr>
                {channel !== 'FORM' && <tr className="table-row">
                  <td className="table-cell-header">
                    {t("common.conversation")}
                  </td>
                  <td className="table-cell">
                    <Tooltip placement="top" title="View Conversation">
                      <button
                        className="btn p-0"
                        onClick={() => handleConversation(vonageCallId)}
                      >
                        <FontAwesomeIcon icon={faEye} className="fs-6 cs-color" />
                      </button>
                    </Tooltip>
                  </td>
                </tr>}
                <tr className="table-row">
                  <td className="table-cell-header">{t("common.status")}</td>
                  <td className="table-cell">
                    <span className={`${getStatusClass(status)}`}>
                      {status}
                    </span>
                  </td>
                </tr>
                <tr className="table-row">
                  <td className="table-cell-header">{t("common.statusReason")}</td>
                  <td className="table-cell">
                    <TextField
                      select
                      fullWidth
                      variant="outlined"
                      onChange={(e) => { handleChangeStatusReason(e, vonageCallId) }}
                      value={statusReason ?? reasonArray[0].label}
                      className='nav-link dealers-dropdown'
                    >
                      {reasonArray.map((option: any, index: number) => (
                        <MenuItem key={option.value + index} value={option.label}>
                          {option.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </td>
                </tr>
                <tr className="table-row">
                  <td className="table-cell-header">{t("common.comment")}</td>
                  <td className="table-cell">
                    <div className="manual-comment">
                      {isEdit ? (
                        <>
                          <textarea
                            value={commentValue}
                            onChange={(e) => handleCommentChange(e)}
                            placeholder="Enter comment"
                            style={{ width: '100%' }}
                          />
                        </>
                      ) : (
                        <span className="comment-value">  {commentValue || ""}
                        </span>
                      )}
                      {
                        <button
                          className="edit-button"
                          onClick={() => {
                            if (isEdit) {
                              submitComment(commentValue, vonageCallId);
                            } else {
                              setIsEdit(true);
                            }
                          }
                          }
                        >
                          <FontAwesomeIcon
                            icon={isEdit ? faSave : faEdit}
                            className="edit-icon"
                          />
                        </button>
                      }
                    </div>
                  </td>
                </tr>
                <tr className="table-row">
                  <td className="table-cell-header">{t("common.callArrivedAt")}</td>
                  <td className="table-cell">{convertUTCToLocalTime(createdAt)}</td>
                </tr>
                {
                  channel === 'CALL' && (
                    <tr className="table-row">
                      <td className="table-cell-header">{t("common.disconnectedBy")}</td>
                      <td className="table-cell">
                        {
                          <FontAwesomeIcon icon={
                            disconnectedBy === 'user' ? faUser :
                              status === 'TRANSFERRED' ? faUserTie :
                                faRobot
                          }
                            title={
                              disconnectedBy === 'user' ? 'Customer' :
                                status === 'TRANSFERRED' ? 'Representative' :
                                  'Agent'
                            } className="fs-6 cs-color" />

                        }
                      </td>
                    </tr>
                  )
                }
                {channel === 'CALL' && <tr className="table-row">
                  <td className="table-cell-header">
                    {t("common.botRecLnk")}
                  </td>
                  <td className="table-cell">
                    {callAttachment &&
                      callAttachment.length > 0 &&
                      callAttachment[0].botRecLnk
                      ? <div className={`bubble`}>
                        <AudioPlayer url={callAttachment[0].botRecLnk} id="botRecLnk" />
                      </div>
                      : "-"}
                  </td>
                </tr>}
                {((status === 'TRANSFERRED' || (status === 'BOOKED' && callAttachment?.[0]?.agentRecLnk)) && channel === 'CALL') && <tr className="table-row">
                  <td className="table-cell-header">
                    {t("common.agentRecLnk")}
                  </td>
                  <td className="table-cell">
                    {callAttachment &&
                      callAttachment.length > 0 &&
                      callAttachment[0].agentRecLnk
                      ? <div className={`bubble`}>
                        <AudioPlayer url={callAttachment[0].agentRecLnk} id="agentRecLnk" />
                      </div>
                      : "-"}
                  </td>
                </tr>}
              </tbody>
            </table>
          </div>
        </div>
        <ConversationDetailModal
          conversations={conversations}
          showConversationModal={showConversationModal}
          setShowConversationModal={setShowConversationModal}
          selectedCall={selectedCall}
          modalType={channel}
        />
      </AudioProvider>
    </>
  );
};

export default CallDetailModal;